// Чистые функции для параметров адреса (без react-router): их можно тестировать отдельно.
export function readSearchParams() {
  return new URLSearchParams(window.location.search);
}

// Чистая функция: применяет изменения к строке запроса. Возвращает новую строку ('' или '?a=b') и признак,
// изменилось ли что-то. Пустое значение удаляет параметр.
export function mergeSearch(search, patch) {
  const next = new URLSearchParams(search);
  let changed = false;
  Object.entries(patch || {}).forEach(([key, value]) => {
    const current = next.get(key);
    if (value === '' || value === null || value === undefined) {
      if (current !== null) { next.delete(key); changed = true; }
    } else if (current !== String(value)) {
      next.set(key, String(value));
      changed = true;
    }
  });
  const qs = next.toString();
  return { search: qs ? `?${qs}` : '', changed };
}
